// extracted by mini-css-extract-plugin
export default {"parent":"Update_parent__xjTk7","child":"Update_child__ky0yz","name":"Update_name__fFeSo","headings":"Update_headings__OAQ2j"};